import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["timestamp", "refreshBtn", "refreshIcon", "countdown"]
  static values  = { interval: { type: Number, default: 60 } }

  connect() {
    this._remaining = this.intervalValue
    this._timer     = setInterval(() => this._tick(), 1000)
  }

  disconnect() {
    clearInterval(this._timer)
    clearTimeout(this._loadingTimeout)
  }

  _tick() {
    this._remaining--
    this._updateCountdown()
    if (this._remaining <= 0) this.refresh()
  }

  _updateCountdown() {
    if (this.hasCountdownTarget) {
      this.countdownTarget.textContent = `${this._remaining}s`
    }
  }

  refresh() {
    this._remaining = this.intervalValue
    this._updateCountdown()

    const frames = [...document.querySelectorAll("turbo-frame[id^='health-']")]
    if (!frames.length) return

    this._setLoading(true)

    // Track when all frames have finished loading, then clear the loading state.
    let loaded = 0
    const onFrameLoad = () => {
      if (++loaded >= frames.length) this._setLoading(false)
    }
    frames.forEach(frame => frame.addEventListener("turbo:frame-load", onFrameLoad, { once: true }))

    // Safety fallback: clear loading state after 30s even if a frame never fires.
    clearTimeout(this._loadingTimeout)
    this._loadingTimeout = setTimeout(() => this._setLoading(false), 30_000)

    frames.forEach(frame => frame.reload())

    if (this.hasTimestampTarget) {
      this.timestampTarget.textContent = new Date().toLocaleTimeString("en-US", {
        hour12: false, hour: "2-digit", minute: "2-digit", second: "2-digit"
      })
    }
  }

  _setLoading(loading) {
    if (this.hasRefreshBtnTarget) {
      this.refreshBtnTarget.disabled = loading
    }
    if (this.hasRefreshIconTarget) {
      this.refreshIconTarget.classList.toggle("animate-spin", loading)
    }
  }
}
